import { IConfiguredHttp } from './http';

export interface IImporterApi {
	importAirbnb: (propertyId: string, customerId: string) => Promise<any>;
	importAirbnbPhotos: (airbnbPropertyId: string, tnPropertyId: number) => Promise<any>;
}

const importerApiFactory = (http: IConfiguredHttp, prefix = ''): IImporterApi => ({
	importAirbnb(propertyId: string, customerId: string) {
		const data = {
			airbnb_ids: [propertyId],
			owner_id: customerId
		};
		return http.post(`${prefix}/airbnb`, data);
	},
	importAirbnbPhotos(airbnbPropertyId: string, tnPropertyId: number) {
		const data = {
			airbnb_id: airbnbPropertyId,
			property_id: tnPropertyId
		};
		return http.post(`${prefix}/airbnb`, data);
	}
});

export default importerApiFactory;
